module.exports = __webpack_public_path__ + "img/haukkala_sisalta.9dbe2dd3.jpg";